import { render, staticRenderFns } from "./FilaRequisicoesTabela.vue?vue&type=template&id=b051c55a&scoped=true"
import script from "./FilaRequisicoesTabela.vue?vue&type=script&lang=js"
export * from "./FilaRequisicoesTabela.vue?vue&type=script&lang=js"
import style0 from "./FilaRequisicoesTabela.vue?vue&type=style&index=0&id=b051c55a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b051c55a",
  null
  
)

export default component.exports